import { render, staticRenderFns } from "./FeaturePlaceholder.vue?vue&type=template&id=4610648c&"
import script from "./FeaturePlaceholder.vue?vue&type=script&lang=js&"
export * from "./FeaturePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports